import { Route, Routes } from 'react-router-dom';
import { File } from './company-documents/file';
import { FreeTemplates } from '../../free-templates/FreeTemplates';
import { DocKind } from '../../free-templates/types';
import { GqlCompany } from '../../graphql/base-types.graphql';

export const Documents = ({
  showNewDocumentDialog,
}: {
  showNewDocumentDialog: (
    kind: DocKind,
    company: Pick<GqlCompany, 'id' | 'name' | 'organizationNumber' | 'addressAsStr'>,
  ) => Promise<boolean>;
}) => {
  return (
    <Routes>
      <Route path="company-documents" element={<File showNewDocumentDialog={showNewDocumentDialog} />}>
        <Route path=":fileId" element={<File showNewDocumentDialog={showNewDocumentDialog} />} />
      </Route>
      <Route path="free-templates" element={<FreeTemplates isInPlatform />} />
    </Routes>
  );
};
